import React from 'react';
import Icon from '@ant-design/icons';
import styled from '@emotion/styled';
import { Avatar } from 'antd';
import Card from '..';
import { ReactComponent as PDFIcon } from 'assets/icons/extensions/pdf.svg';
import { ReactComponent as DOCIcon } from 'assets/icons/extensions/doc.svg';
import { ReactComponent as PNGIcon } from 'assets/icons/extensions/png.svg';
import { ReactComponent as XLSIcon } from 'assets/icons/extensions/xls.svg';
import { ReactComponent as JPGIcon } from 'assets/icons/extensions/jpeg.svg';
import { formatBytes } from 'app/utils';
const FILE_EXTENSIONS: { [key: string]: any } = {
  pdf: <Icon style={{ fontSize: 28 }} component={PDFIcon} />,
  doc: <Icon style={{ fontSize: 28 }} component={DOCIcon} />,
  docx: '',
  xls: <Icon style={{ fontSize: 28 }} component={XLSIcon} />,
  png: <Icon style={{ fontSize: 28 }} component={PNGIcon} />,
  jpeg: <Icon style={{ fontSize: 28 }} component={JPGIcon} />
};

type Props = {
  file: {
    fileName: string;
    fileSize: number;
    url: string;
    fileType: string;
    originFileObj: File;
    [key: string]: any;
  };
  showIcon?: boolean;
};

const StyledCard = styled(Card)`
  cursor: pointer;
  width: 100%;

  .ant-avatar {
    height: 35px;
    border-radius: 0px;
    background: transparent;
    &.fileIcon {
      width: 35px;
      height: 35px;
      > span {
        width: 100%;
        height: 100%;
      }
      svg {
        width: 100%;
        height: 100%;
      }
    }
  }
  .ant-card-meta-detail > div:not(:last-child) {
    margin-bottom: 0;
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    letter-spacing: 0.002em;
    text-align: left;
  }
  .ant-card-meta-description {
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: 0.005em;
    text-align: left;
  }
`;
const CardFile = (props: Props) => {
  const { showIcon } = props;
  const [url, setUrl] = React.useState('');

  const extension = React.useMemo(() => {
    const regex = /(image\/|application\/)/g;
    if (!props.file) return null;
    const fileExt =
      props.file?.fileType || props.file?.type || props.file?.mineType || '';
    return fileExt.replace(regex, '');
  }, [props.file]);
  React.useEffect(() => {
    if (props.file.originFileObj) {
      // File before upload;
      const url = URL.createObjectURL(props.file.originFileObj);
      setUrl(url);
      return () => URL.revokeObjectURL(url);
    }
    setUrl(props.file?.url);
  }, [props.file]);
  return (
    <StyledCard
      bordered={false}
      onClick={() => {
        window.open(url, '_blank');
      }}
    >
      <Card.Meta
        avatar={
          <Avatar
            className={showIcon ? 'fileIcon' : ''}
            shape="square"
            size={'large'}
            src={showIcon ? null : url}
          >
            {FILE_EXTENSIONS[extension]}
          </Avatar>
        }
        title={props.file?.fileName || props.file?.name}
        description={formatBytes(
          +(props?.file?.fileSize || props?.file?.size || 0)
        )}
      ></Card.Meta>
    </StyledCard>
  );
};

export default CardFile;
